import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import AuthHandler from 'components/auth/AuthHandler/AuthHandler';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import FullPageLoader from 'components/Loader/FullPageLoader/FullPageLoader';
import classes from './App.module.css';
import 'assets/css/modal.css';
import { createQueryClient } from 'utils/QueryClient';

const loadAuthenticatedApp = () => import('./AppMain');
const AuthenticatedApp = React.lazy(loadAuthenticatedApp);

const queryClient = createQueryClient();

function App() {
  useEffect(() => {
    loadAuthenticatedApp();
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <div className={classes.app} data-cy="app">
          <ErrorBoundary>
            <AuthHandler>
              <React.Suspense fallback={<FullPageLoader />}>
                <AuthenticatedApp />
              </React.Suspense>
            </AuthHandler>
          </ErrorBoundary>
        </div>
      </Router>
      <ReactQueryDevtools />
    </QueryClientProvider>
  );
}

export default App;
